import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import { use, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { MdArrowBack, MdVisibility } from 'react-icons/md';
import { MdVisibilityOff } from 'react-icons/md';
import { MdLock } from 'react-icons/md';
import axios from 'axios';
import { web_url } from '../../constant';


function ResearcherChangeStudentForgotPasswordCommonPage() {

    const [language, setLanguage] = useState(() => {
        const categoryNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return categoryNow;
    })
    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);
    const navigate = useNavigate();

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };

    const location = useLocation();
    const [email, setEmail] = useState("");

    const [userNewPasswordDetails, setUserNewPasswordDetails] = useState(
        {
            password: '',
            confirmPassword: '',
        }
    )
    const [openError, setOpenError] = useState(false);
    const [error, setError] = useState('');

    const handleClickOpenError = (err) => {
        // console.log(err);

        if (err.toLowerCase().includes('internal server error')) {
            setError(t('t93'));
        } else if (err.toLowerCase().includes('not found with the provided email')) {
            setError(t('t349'));
        } else if (err.toLowerCase().includes('you have not requested a password change')) {
            setError(t('t274'));
        } else if (err.toLowerCase().includes('invalid credentials')) {
            setError(t('t100'));
        } else {
            setError(t('t94'));
        }
        setOpenError(true);
    };

    const handleCloseError = () => {
        setOpenError(false);
        localStorage.removeItem('/')
        navigate('/loginas')
    };

    const [errors, setErrors] = useState(
        {
            noPassword: false,
            passwordsNotMatch: false,
        }
    )

    useEffect(() => {
        const getEmail = () => {
            const emailFromStorage = localStorage.getItem('studentEmailForResetPassword');
            if (emailFromStorage) {
                setEmail(emailFromStorage);
                setUserNewPasswordDetails((prevState) => ({
                    ...prevState, password: '', confirmPassword: ''
                }));
            } else {
                navigate('/researcher/resetpassword/student/check');
            }
        };

        getEmail();
    }, [])

    const handleContinue = () => {
        // console.log(userNewPasswordDetails);

        let newErrors = {};

        newErrors.noPassword = !userNewPasswordDetails.password;

        if (userNewPasswordDetails.password && (userNewPasswordDetails.confirmPassword) !== (userNewPasswordDetails.password)) {
            newErrors.passwordsNotMatch = true;
        } else {
            newErrors.passwordsNotMatch = false;
        }

        setErrors(newErrors);

        if (Object.values(newErrors).some((error) => error)) {
            return;
        }

        const userEmail = localStorage.getItem('studentEmailForResetPassword');
        const user = {
            newPassword: userNewPasswordDetails.password,
            userRole: "STUDENT"
        };

        setIsLoading(true);

        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${logDetails.token}`,
            },
        };

        axios.put(`${web_url}/api/auth/change-password/${userEmail}`, user, config)
            .then((response) => {
                console.log("API Response:", response.data);
                setIsLoading(false);
                setOpen2(true);
            })
            .catch((errChaneg) => {
                setIsLoading(false);
                console.log(errChaneg);

                if (errChaneg?.response?.data) {
                    // console.log(errFor.response.data)
                    if (errChaneg.response.data) {
                        handleClickOpenError(errChaneg.response.data);
                    } else if (errChaneg.response.data.message) {
                        handleClickOpenError(errChaneg.response.data.message);
                    } else if (errChaneg.response.data.token) {
                        handleClickOpenError(errChaneg.response.data.token);
                    } else {
                        handleClickOpenError("An unknown error occured");
                    }

                }
            })
    }

    const [isVisible, setIsVisible] = useState(false);
    const [isVisibleText, setIsVisibleText] = useState(true);

    const [isVisible2, setIsVisible2] = useState(false);
    const [isVisibleText2, setIsVisibleText2] = useState(true);

    const handleVisiblityClick = () => {
        setIsVisible(!isVisible);
        if (!isVisible && userNewPasswordDetails.password.length > 0) {
            setIsVisibleText(true);
        } else if (isVisible && userNewPasswordDetails.password.length > 0) {
            setIsVisibleText(false);
        }
    }

    const handleVisiblityClick2 = () => {
        setIsVisible2(!isVisible2);
        if (!isVisible2 && userNewPasswordDetails.password.length > 0) {
            setIsVisibleText2(true);
        } else if (isVisible2 && userNewPasswordDetails.password.length > 0) {
            setIsVisibleText2(false);
        }
    }

    const [passwordStatus, setPasswordStatus] = useState({
        weak: false,
        medium: false,
        strong: false
    })

    const errorMessages =
        [
            '',
            t('t60'),
            t('t61'),
            t('t62'),
            t('t63'),
            t('t64'),
        ]

    const [errorMessageNumber, setErrorMessageNumber] = useState(0)

    const regexPatterns = [
        /^.{1,7}$/,  // weak password
        /^(?:[a-z]{8,}|[A-Z]{8,}|[0-9]{8,}|[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{8,})$/,  // medium password
        /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#*$%^&+=]).{8,}$/,  // strong password
        /(?=.*[A-Z])/,  // contains at least 1 uppercase letter
        /(?=.*[a-z])/,  // contains at least 1 lowercase letter
        /(?=.*[0-9])/,  // contains at least 1 numeric digit
        /(?=.*[!@#*$%^&+=])/,  // contains at least 1 special character
        /^.{8,}$/,  // password length greater than 8 characters
    ];

    const [isLoading, setIsLoading] = useState(false);
    const [open2, setOpen2] = useState(false);

    const handleClose2 = () => {
        setOpen2(false);
    };

    useEffect(() => {

        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };

        const checkAuth = () => {
            const logDetails = getLogDetails();
            const currentTime = new Date();

            if (!logDetails) {
                alert("Please re-sign up to continue");
                localStorage.clear();
                sessionStorage.clear();
                navigate('/loginas');
                return;
            } else if (logDetails.category.toLowerCase() !== "researcher") {
                alert("Please re-sign up to continue");
                // localStorage.clear();
                sessionStorage.clear();
                navigate('/loginas');
                return;
            }

            if (sessionStorage.getItem('exp')) {
                if (new Date(sessionStorage.getItem('exp')) < currentTime) {
                    alert("Please re-sign up to continue");
                    localStorage.clear();
                    sessionStorage.clear();
                    navigate('/loginas');
                } else if (sessionStorage.getItem('exp') !== logDetails.exp) {
                    alert("Please re-sign up to continue");
                    sessionStorage.clear();
                    navigate('/loginas');
                }
            } else {
                sessionStorage.setItem('exp', logDetails.exp);
                if (new Date(logDetails.exp) < currentTime) {
                    alert("Please re-sign up to continue");
                    localStorage.clear();
                    sessionStorage.clear();
                    navigate('/loginas');
                }
            }
        };

        checkAuth(); // Run on mount

        const handleStorageChange = (event) => {
            if (event.key === "logDetails") {
                checkAuth(); // Re-check authentication if storage changes
            }
        };

        window.addEventListener("storage", handleStorageChange);

        return () => {
            window.removeEventListener("storage", handleStorageChange);
        };
    }, []);

    return (
        <div className={`min-h-screen overflow-y-auto overflow-x-hidden ${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")} bg-bgImg md:bg-bglarge bg-repeat bg-cover w-screen xl:pt-[50px]`}>
            <div className="xl:hidden absolute top-0 left-0 py-[25px] pl-[20px] md:pl-[30px] lg:pl-[40px]">
                <div className="flex justify-center items-center" >
                    <img className="h-[50px] md:h-[70px] lg:h-[90px]" src="/images/logo.svg" alt="logo" />
                    <p className="ml-[10px] mr-[100px]  font-semibold text-[15px] md:text-[20px] lg:text-[25px]">{t('t1')}</p>
                </div>
            </div>
            <Menu as="div" className="xl:hidden absolute top-0 right-0 text-left items-right py-[30px] md:py-[35px] pr-[20px] md:pr-[30px] lg:pr-[40px]">
                <div>
                    <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 lg:py-3 text-sm md:text-[17px] md:text-[21px] font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-black hover:bg-gray-50">
                        {language === "Sinhala" ? "සිංහල" : (language === "Tamil" ? "தமிழ்" : language)}
                        <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 md:size-6 text-gray-400" />
                    </MenuButton>
                </div>

                <MenuItems
                    transition
                    className="absolute right-0 z-10 mt-2 w-[200px] origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                >
                    <div className="py-1">
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("English");
                                    changeLanguage('en')
                                }}
                            >
                                English
                            </button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("Sinhala");
                                    changeLanguage('si')
                                }}
                            >
                                සිංහල
                            </button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("Tamil");
                                    changeLanguage('ta')
                                }}
                            >
                                தமிழ்
                            </button>
                        </MenuItem>
                    </div>
                </MenuItems>
            </Menu>
            <div className="rounded-md hidden xl:grid grid-cols-3 py-[5px] 2xl:py-[10px] bg-gradient-to-r from-[#FFA803] to-[#FFD12E] mx-[70px] px-[20px]">
                <div className="flex justify-start items-center">
                    <img className="h-[40px]" src="/images/logo.svg" alt="logo" />
                    <p className="ml-[10px] font-semibold text-[20px]">{t('t1')}</p>
                </div>
                <div className="grid grid-cols-3 w-full">
                    <div className="flex justify-center py-[10px] cursor-pointer relative group">
                        <img src="/images/top-icons/home-b.svg" alt="home" onClick={() => navigate('/desktop/researcher/dashboard')} />
                        <span className="absolute bottom-full mb-2 px-2 py-1 text-white text-sm bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                            {t('t410')}
                        </span>
                    </div>
                    <div className="flex justify-center py-[10px] cursor-pointer relative group">
                        <img src="/images/top-icons/mail-b.svg" alt="mail" onClick={() => {
                            const mailRequest = {
                                type: 'new',
                                subject: 'nothing'
                            };
                            localStorage.setItem('threadId', JSON.stringify(mailRequest));
                            navigate('/desktop/researcher/mailbox')

                        }} />
                        <span className="absolute bottom-full mb-2 px-2 py-1 text-white text-sm bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                            {t('t411')}
                        </span>
                    </div>
                    <div className="flex justify-center py-[10px] cursor-pointer relative group">
                        <img src="/images/top-icons/settings-b.svg" alt="settings" onClick={() => navigate('/desktop/researcher/settings')} />
                        <span className="absolute bottom-full mb-2 px-2 py-1 text-white text-sm bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                            {t('t153')}
                        </span>
                    </div>
                </div>
                <div className="flex justify-end items-center">
                    <Menu as="div" className="text-left items-right">
                        <div>
                            <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 lg:py-3 text-sm md:text-[17px] md:text-[21px] font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-black hover:bg-gray-50">
                                {language === "Sinhala" ? "සිංහල" : (language === "Tamil" ? "தமிழ்" : language)}
                                <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 md:size-6 text-gray-400" />
                            </MenuButton>
                        </div>

                        <MenuItems
                            transition
                            className="absolute right-0 z-10 mt-2 w-[200px] origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                        >
                            <div className="py-1">
                                <MenuItem>
                                    <button
                                        className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                        onClick={() => {
                                            setLanguage("English");
                                            changeLanguage('en')
                                        }}
                                    >
                                        English
                                    </button>
                                </MenuItem>
                                <MenuItem>
                                    <button
                                        className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                        onClick={() => {
                                            setLanguage("Sinhala");
                                            changeLanguage('si')
                                        }}
                                    >
                                        සිංහල
                                    </button>
                                </MenuItem>
                                <MenuItem>
                                    <button
                                        className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                        onClick={() => {
                                            setLanguage("Tamil");
                                            changeLanguage('ta')
                                        }}
                                    >
                                        தமிழ்
                                    </button>
                                </MenuItem>
                            </div>
                        </MenuItems>
                    </Menu>
                </div>
            </div>
            <div className="ml-[30px] md:ml-[60px] lg:ml-[80px] xl:ml-[80px] w-full flex justify-start flex items-center pt-[100px] md:pt-[150px] xl:pt-[50px]">
                <MdArrowBack size={25} className="md:hidden" onClick={() => {
                    navigate('/researcher/resetpassword/student/check')
                }} />
                <MdArrowBack size={30} className="hidden md:block xl:hidden" onClick={() => {
                    navigate('/researcher/resetpassword/student/check')
                }} />
                <MdArrowBack size={30} className="hidden xl:block" onClick={() => {
                    navigate('/researcher/resetpassword/student/check')
                }} />
            </div>
            <div className='w-full h-full flex justify-center items-center pt-[10px] pb-[100px] xl:pt-[10px] xl:pb-[100px] px-[10px]'>
                <div className='flex flex-col justify-center h-full sm:w-full sm:w-full md:w-[400px] lg:w-[500px] xl:w-[500px]  2xl:w-[500px]'>
                    <img src="/images/changed.svg" className="h-[150px]" alt='logo' />
                    <p className="text-center text-[20px] mt-[10px]">{t('t76')}</p>

                    {
                        isLoading ?
                            <div className="items-center justify-center flex pt-[30px]">
                                <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                            </div> :
                            <>
                                <div className="items-center mt-[20px] flex rounded-md bg-[#F1F6FB] pl-[10px] pr-[20px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                    <MdLock size="26px" color="#8189B0" />
                                    <input
                                        type={isVisibleText ? "text" : "password"}
                                        name="password"
                                        className={`ml-[10px] mr-[10px] w-full bg-[#F1F6FB] text-gray-900 text-[15px] ${isVisibleText ? 'text-[15px] tracking-wide' : 'text-[25px] tracking-widest'} placeholder:text-[#8189B0] focus:outline focus:outline-0`}
                                        placeholder={t('t17')}
                                        value={userNewPasswordDetails.password}
                                        onChange={(e) => {

                                            const inputValue = e.target.value.replace(/\s+/g, '').trim();
                                            if (inputValue !== "") {
                                                setErrors((prev) => ({ ...prev, noPassword: false }));
                                                if (regexPatterns[2].test(inputValue)) {
                                                    setPasswordStatus((prev) => ({ ...prev, medium: false, weak: false, strong: true }));

                                                } else if (regexPatterns[1].test(inputValue)) {
                                                    setPasswordStatus((prev) => ({ ...prev, medium: true, weak: false, strong: false }));

                                                } else if (regexPatterns[0].test(inputValue)) {
                                                    setPasswordStatus((prev) => ({ ...prev, medium: false, weak: true, strong: false }));

                                                } else {
                                                    setPasswordStatus((prev) => ({ ...prev, medium: true, weak: false, strong: false }));

                                                }
                                            } else {
                                                setErrors((prev) => ({ ...prev, noPassword: false }));
                                                setPasswordStatus((prev) => ({ ...prev, medium: false, weak: false, strong: false }));
                                            }

                                            if (inputValue !== '') {
                                                if (!regexPatterns[3].test(inputValue)) {
                                                    setErrorMessageNumber(1)
                                                } else if (!regexPatterns[4].test(inputValue)) {
                                                    setErrorMessageNumber(2)
                                                } else if (!regexPatterns[5].test(inputValue)) {
                                                    setErrorMessageNumber(3)
                                                } else if (!regexPatterns[6].test(inputValue)) {
                                                    setErrorMessageNumber(4)
                                                } else if (!regexPatterns[7].test(inputValue)) {
                                                    setErrorMessageNumber(5)
                                                } else {
                                                    setErrorMessageNumber(0)
                                                }
                                            } else {
                                                setErrorMessageNumber(0)
                                            }

                                            setUserNewPasswordDetails((prevState) => ({
                                                ...prevState, password: inputValue
                                            }));
                                            if (!isVisible && inputValue.length > 0) {
                                                setIsVisibleText(false);
                                            } else {
                                                setIsVisibleText(true);
                                            }
                                        }}
                                    />
                                    {
                                        isVisible ? <MdVisibilityOff onClick={handleVisiblityClick} size="24px" color="#8189B0" /> : <MdVisibility onClick={handleVisiblityClick} size="24px" color="#8189B0" />
                                    }
                                </div>

                                {errors.noPassword &&
                                    <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t18')}</p>
                                }

                                {passwordStatus.weak && <p className='text-black text-[12px] mt-[5px] '>{t('t65')}<span className='text-[#fc0000] font-bold'>{t('t66')}</span></p>
                                }
                                {passwordStatus.medium && <p className='text-black text-[12px] mt-[5px]'>{t('t65')}<span className='text-[#fc8600] font-bold'>{t('t67')}</span></p>
                                }
                                {passwordStatus.strong && <p className='text-black text-[12px] mt-[5px]'>{t('t65')}<span className='text-[#099509] font-bold'>{t('t68')}</span></p>
                                }

                                {errorMessageNumber !== 0 && <p className='text-[#ff0000] text-[12px] mt-[5px] '>{errorMessages[errorMessageNumber]}</p>}

                                <div className="items-center mt-[20px] flex rounded-md bg-[#F1F6FB] pl-[10px] pr-[20px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                    <MdLock size="26px" color="#8189B0" />
                                    <input type={isVisibleText2 ? "text" : "password"}
                                        name="password_confirm"
                                        className={`ml-[10px] mr-[10px] w-full bg-[#F1F6FB] text-gray-900 text-[15px] ${isVisibleText2 ? 'text-[15px] tracking-wide' : 'text-[25px] tracking-widest'} placeholder:text-[#8189B0] focus:outline focus:outline-0`}
                                        placeholder={t('t30')}
                                        value={userNewPasswordDetails.confirmPassword}
                                        onChange={(e) => {
                                            const inputValue = e.target.value.replace(/\s+/g, '').trim();
                                            setUserNewPasswordDetails((prevState) => ({
                                                ...prevState, confirmPassword: inputValue
                                            }));
                                            if (!isVisible2 && inputValue.length > 0) {
                                                setIsVisibleText2(false);
                                            } else {
                                                setIsVisibleText2(true);
                                            }
                                        }}
                                    />
                                    {
                                        isVisible2 ? <MdVisibilityOff onClick={handleVisiblityClick2} size="24px" color="#8189B0" /> : <MdVisibility onClick={handleVisiblityClick2} size="24px" color="#8189B0" />
                                    }
                                </div>
                                {errors.passwordsNotMatch &&
                                    <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t26')}</p>
                                }
                                <button onClick={handleContinue} className="text-[18px] mt-[40px] rounded-lg pt-[10px] pb-[10px] w-full hover:bg-opacity-80 bg-gradient-to-r from-[#FFA803] to-[#FFD12E] ">{t('t52')}</button>

                            </>
                    }


                </div>
            </div>

            <div className="xl:hidden grid grid-cols-4 fixed bottom-0 w-full border-t border-gray-300 bg-white">
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/home.svg" alt="home" onClick={() => navigate('/mobile/researcher/dashboard')} /></div>
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/person.svg" alt="person" onClick={() => navigate('/mobile/researcher/profile')} /></div>
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/mail.svg" alt="mail" onClick={() => navigate('/mobile/researcher/mailbox/inbox')} /></div>
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/settings.svg" alt="settings" onClick={() => navigate('/mobile/researcher/settings')} /></div>
            </div>
            <Dialog
                open={open2}
                onClose={handleClose2}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogContent className="bg-[#FFF6DA]">
                    {!isLoading &&
                        <DialogContent
                            id="custom-dialog-description"
                            className="text-gray-600 text-md mt-2"
                        >
                            <div className='flex flex-col justify-center items-center text-center'>
                                <img src='/images/passChanged.svg' alt='changed' />
                                <div className='mt-[30px]'>{t('t78_1')}</div>
                            </div>
                        </DialogContent>
                    }

                </DialogContent>
                <DialogActions className="px-4 py-2 bg-[#FFF6DA]">
                    <Button
                        onClick={() => {
                            navigate('/researcher/resetpassword/student/check')
                        }}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t7')}
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={openError}
                onClose={handleCloseError}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogTitle
                    id="custom-dialog-title"
                    className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                >
                    {t('t95')}
                </DialogTitle>
                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {error}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleCloseError}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t96')}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default ResearcherChangeStudentForgotPasswordCommonPage;